import { render, staticRenderFns } from "./ExibirOnus.vue?vue&type=template&id=51f6671a&scoped=true&"
import script from "./ExibirOnus.vue?vue&type=script&lang=js&"
export * from "./ExibirOnus.vue?vue&type=script&lang=js&"
import style0 from "./ExibirOnus.vue?vue&type=style&index=0&id=51f6671a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f6671a",
  null
  
)

export default component.exports